import React from 'react';
import { cssColorValue, desktopMestoBold, IconChevronDown, IconChevronUp, NavBar, NavBarList, screenMdMin, spacer32, spacer8, } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { ButtonTertiaryLink, FrodorTextLink } from '../Link/Link';
import { NavBarPopover } from './Popover';
import { hexToRgba } from '../../utils/colorConversion';
import { trackCat } from './constants';
import { isMastheadLink, isMastheadLinkList, isMastheadLinkListItem, } from '../../utils/contentful';
import { trackingAttributes } from '../../lib/buildTrackingAttributes';
import { isNotUndefined } from '../../lib/isNotUndefined';
import useDropdown from './hooks/useDropdown';
import { ActiveSubmenuContextProvider } from '../ActiveSubmenu/ActiveSubmenuProvider';
const StyledNavBar = styled(NavBar) `
  @media (max-width: ${screenMdMin}) {
    display: none;
  }
`;
const StyledNavBarList = styled(NavBarList) `
  gap: ${spacer32};
  line-height: 24px;
  margin: 0;
  overflow-x: visible;
  padding: 0;
  ${desktopMestoBold};
`;
const NavLink = styled(FrodorTextLink) `
  cursor: pointer;
  ${desktopMestoBold};

  && {
    color: ${props => { var _a; return hexToRgba(((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'), 0.75); }};
    text-decoration: none;

    &:active,
    &:hover,
    &:focus {
      color: ${props => { var _a; return ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
      text-decoration: none;
    }
  }
`;
const NavBarPopoverButton = styled(ButtonTertiaryLink) `
  cursor: pointer;
  ${desktopMestoBold};

  && {
    color: ${props => { var _a; return hexToRgba(((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'), 0.75); }};
    text-decoration: none;

    &:active,
    &:hover,
    &:focus {
      color: ${props => { var _a; return ((_a = props.colors) === null || _a === void 0 ? void 0 : _a.text) || cssColorValue('textBase'); }};
      transform: none;
    }

    & > * {
      margin-inline-start: ${spacer8};
    }
  }
`;
const StyledIconChevronDown = styled(IconChevronDown) `
  transform: translateY(1px);
`;
const StyledIconChevronUp = styled(IconChevronUp) `
  transform: translateY(3px);
`;
const NavbarDropdown = ({ mastheadData, linkListEntry, colors, }) => {
    const { handlers, open } = useDropdown(linkListEntry.sys.id);
    const links = linkListEntry.fields.entries
        ? linkListEntry.fields.entries
            .filter(isMastheadLinkListItem)
            .map(linkListItem => {
            const link = linkListItem.fields.mastheadLink;
            return {
                trackingAttributes: trackingAttributes(trackCat, link.fields.trackingId),
                href: link.fields.href,
                linkText: link.fields.title,
                level: linkListItem === null || linkListItem === void 0 ? void 0 : linkListItem.fields.nestingLevel,
                openInNewWindow: link.fields.target === 'blank',
            };
        })
        : [];
    return (React.createElement(NavBarPopover, { isOpen: open, links: links, onMouseEnter: handlers.handleOnMouseEnter, onMouseLeave: handlers.handleOnMouseLeave },
        React.createElement(NavBarPopoverButton, { colors: colors, href: "", iconTrailing: () => open ? (React.createElement(StyledIconChevronUp, { size: "small", "aria-label": mastheadData.fields.dropdownMenuLabelClose })) : (React.createElement(StyledIconChevronDown, { size: "small", "aria-label": mastheadData.fields.dropdownMenuLabelOpen })), trackingAttributes: ['', ''], onKeyDown: handlers.handleOnKeyDown, onMouseDown: handlers.handleOnMouseDown }, linkListEntry.fields.label)));
};
export const NavBarLinks = ({ mastheadData, colors, entries }) => {
    return (React.createElement(StyledNavBar, { list: React.createElement("nav", { dir: "ltr" },
            React.createElement(StyledNavBarList, null,
                React.createElement(ActiveSubmenuContextProvider, null, entries.filter(isNotUndefined).map((item, index) => {
                    if (isMastheadLink(item)) {
                        return (React.createElement("li", { key: item.fields.trackingId },
                            React.createElement(NavLink, { href: item.fields.href, openInNewWindow: item.fields.target === 'blank', id: item.fields.htmlId, trackingAttributes: [trackCat, item.fields.trackingId], colors: colors }, item.fields.title)));
                    }
                    if (isMastheadLinkList(item)) {
                        return (React.createElement("li", { key: item.fields.label + index },
                            React.createElement(NavbarDropdown, { mastheadData: mastheadData, colors: colors, linkListEntry: item })));
                    }
                    return React.createElement("div", null);
                })))) }));
};
//# sourceMappingURL=Links.js.map